// extracted by mini-css-extract-plugin
export default {"stockIndicator":"dxhEAi","stickyDrawer":"Ruu28E","outOfStockIndicator":"c2lve_"};